import React from 'react';

export const VerticalSpace = ({ size }) => {
  return (
    <div
      style={{
        width: '100%',
        height: `${size}px`
      }}
    />
  );
};


export const HorizontalSpace = ({ size }) => {
  return (
    <div
      style={{
        height: '100%',
        width: `${size}px`
      }}
    />
  );
};